import SystemNotification, { SystemNotificationButtonAction } from "./Model/SystemNotification";
import DOMPurify from 'dompurify';

interface SystemNotificationBannerProps {
    notification : SystemNotification;
    onNotificationAction : (notificationActionType : SystemNotificationButtonAction, notification: SystemNotification) => void;
}

export default function SystemNotificationBanner(props : SystemNotificationBannerProps) {
    const {notification} = props;

    const PrimaryActionButton = () => <button className="mr-2 btn btn-pp-primary" onClick={() => props.onNotificationAction(SystemNotificationButtonAction.PrimaryAction, notification)}>{notification.primaryActionText || "OK"}</button>;
    const CloseButton = () => <button className="btn btn-outline-pp-primary" onClick={() => props.onNotificationAction(SystemNotificationButtonAction.CloseAction, notification)}>{notification.closeButtonText || "Cancel"}</button>;
    const DontRemindMeButton = () => <button className="btn btn-outline-pp-primary" onClick={() => props.onNotificationAction(SystemNotificationButtonAction.DontRemindMeAction, notification)}>{notification.dontRemindButtonText || "Don't Show This Message Again"}</button>

    return <div className="system-notification alert alert-info alert-pp-alert-notice" role="alert">
        {notification.title && <h5 className="alert-heading">{notification.title}</h5>}
        <p dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(notification.body)}}/>
        <hr/>
        <div className="mb-0 d-flex">
            <div className="d-flex justify-content-start flex-grow-1">
                <PrimaryActionButton/>
                <CloseButton/>
            </div>
            <div className="d-flex justify-content-end">
                <DontRemindMeButton/>
            </div>
        </div>
    </div>;
}